// useDoctorLogin.ts
import { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  setDoctorSelectedProfile,
  setDoctorOtp,
  sendDoctorOtpAsync,
  verifyDoctorOtpAsync,
  getDoctorListAsync,
  Doctor,
} from '../../../redux/flows/auth/doctor/index'
import { setCurrentScreen } from '../../../redux/flows/portal'
import { useAppDispatch, useAppSelector } from '../../../redux/store'
import { APIStatus } from '../../../redux/types'
export function useDoctorLogin() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const {
    selectedProfile,
    otp,
    doctorList,
    doctorListStatus,
    doctorListError,
    sendDoctorOtpStatus,
    sendDoctorOtpError,
    verifyDoctorOtpStatus,
    verifyDoctorOtpError,
  } = useAppSelector((state) => state.doctorAuth)

  const [otpSent, setOtpSent] = useState(false)

  useEffect(() => {
    if (doctorListStatus === APIStatus.idle) {
      dispatch(getDoctorListAsync())
    }
  }, [dispatch])

  const sendOtp = (doctor: Doctor) => {
    if (sendDoctorOtpStatus === APIStatus.pending) return

    dispatch(setDoctorSelectedProfile(doctor))
    dispatch(sendDoctorOtpAsync({ id: doctor.id }))
  }

  const resendOtp = () => {
    if (!selectedProfile) return
    sendOtp(selectedProfile)
  }

  const verifyOtp = async () => {
    if (!selectedProfile) return
    if (!otp.trim()) return

    const result = await dispatch(
      verifyDoctorOtpAsync({
        id: selectedProfile.id.toString(),
        code: otp,
      }) as any,
    )

    if (verifyDoctorOtpAsync.fulfilled.match(result)) {
      dispatch(setCurrentScreen('current'))
      navigate('/setup-studio')
    }
  }

  useEffect(() => {
    if (sendDoctorOtpStatus === APIStatus.fulfilled) {
      setOtpSent(true)
    }
  }, [sendDoctorOtpStatus])

  const verifying = useMemo(() => verifyDoctorOtpStatus === APIStatus.pending, [verifyDoctorOtpStatus])

  const otpError = useMemo(
    () => verifyDoctorOtpError || sendDoctorOtpError || '',
    [verifyDoctorOtpError, sendDoctorOtpError],
  )

  return {
    // Doctor list
    doctorList,
    doctorListStatus,
    doctorListError,

    // UI state
    selectedProfile,
    otp,
    otpError,
    otpSent,
    verifying,

    // API statuses
    sendDoctorOtpStatus,
    verifyDoctorOtpStatus,

    // Actions
    setOtp: (v: string) => dispatch(setDoctorOtp(v)),
    selectProfile: (p: any) => dispatch(setDoctorSelectedProfile(p)),
    sendOtp,
    resendOtp,
    verifyOtp,
    navigate,
  }
}
